import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { AdministratorRoutingModule } from '../routes/administrator-routing.module';
import { SharedModule } from './shared.module';
import { ActiveInactiveLabsComponent, AddTestToModelComponent, AdminMainComponent,LabByModelComponent,LabFrequencyAlertComponent,LabManagerComponent,LabRangeAlertComponent,LabRangeAssignComponent,PartMangerMenuComponent,SqaCodeManagerComponent} from '../components';
//import { AdminMainComponent,SqaCodeManagerComponent } from '../components';
import{AdministratorMenuComponent} from '../components/shared/menu/administrator-menu/administrator-menu.component';
import{ServiceRequestComponent} from '../components/administrator/service-request/service-request.component'
import {TicketManagerComponent} from '../components/administrator/ticket-manager/ticket-manager.component';
import{ AlertManagerComponent} from '../components/administrator/alert-manager/alert-manager.component';
import{ BatchManagerComponent} from '../components/administrator/batch-manager/batch-manager.component';
import{PartsManagerComponent}from '../components/administrator/parts-manager/parts-manager.component'

import {ToastModule} from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {CheckboxModule} from 'primeng/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {ProgressSpinnerModule} from 'primeng/progressspinner';

import { SerialNumberMergeComponent} from '../components/administrator/serial-number-merge/serial-number-merge.component'
import {SelectButtonModule} from 'primeng/selectbutton';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputSwitchModule} from 'primeng/inputswitch';
import { NgSelectModule } from '@ng-select/ng-select';
@NgModule({
  declarations: [
    AdminMainComponent,
    AdministratorMenuComponent ,
    ServiceRequestComponent,
    TicketManagerComponent,
    AlertManagerComponent,
    BatchManagerComponent,
    PartsManagerComponent,
    PartMangerMenuComponent,
    SqaCodeManagerComponent,
    SerialNumberMergeComponent,
    LabManagerComponent,
    ActiveInactiveLabsComponent,
    LabByModelComponent,
    LabFrequencyAlertComponent,
    LabRangeAlertComponent,
    LabRangeAssignComponent,
    AddTestToModelComponent
  ],
  exports: [AdminMainComponent],
  entryComponents: [LabRangeAssignComponent,AddTestToModelComponent],
  imports: [
    SharedModule,
    AdministratorRoutingModule,
    ToastModule,
    DropdownModule,
    ConfirmDialogModule,
    CheckboxModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    ProgressSpinnerModule,
    SelectButtonModule,
    InputNumberModule,
    InputSwitchModule,
    NgSelectModule
    
  ],
  schemas :[NO_ERRORS_SCHEMA]

})
export class AdministratorModule { }
